import { render } from "./UnlockBenifits.vue?vue&type=template&id=054da825"
import script from "./UnlockBenifits.vue?vue&type=script&lang=js"
export * from "./UnlockBenifits.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__